module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('PageHeader', {
    attrs: {
      "title": "Define Micro Notes"
    }
  }, [_vm._c('div', {
    staticClass: "pull-right"
  }, [(_vm.chapter && _vm.microNotable()) ? _vm._c('a', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleReplaceWarning($event)
      }
    }
  }, [_vm._c('i', {
    staticClass: "fas fa-save"
  }), _vm._v("   Save changes\n      ")]) : (_vm.chapter) ? _vm._c('a', {
    staticClass: "btn btn-primary btn-lg disabled",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "href": "",
      "disabled": ""
    }
  }, [_vm._c('i', {
    staticClass: "fas fa-save"
  }), _vm._v("   Save changes\n      ")]) : _vm._e(), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn btn-danger btn-lg",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "to": {
        name: 'subject-shelf'
      }
    }
  }, [_vm._c('i', {
    staticClass: "fas fa-arrow-left"
  }), _vm._v("   Cancel\n      ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "text-right pull-right xs-mt-5 xs-mb-10"
  }, [(_vm.chapter) ? _vm._c('KeywordSettings', {
    attrs: {
      "chapterId": _vm.chapter.chapter_id
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "pull-left"
  }, [_vm._c('Help', [_vm._c('div', {
    slot: "content"
  }, [_vm._v("\n          Split your lecture notes into micro notes with the "), _vm._c('span', {
    staticClass: "btn btn-default"
  }, [_vm._c('span', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" button. Select keywords to be hidden/tested with the "), _vm._c('span', {
    staticClass: "btn btn-default"
  }, [_vm._c('span', {
    staticClass: "fa fa-key"
  })]), _vm._v(" button."), _vm._c('br'), _vm._v("\n          Click an image and select "), _vm._c('span', {
    staticClass: "btn btn-default"
  }, [_vm._c('span', {
    staticClass: "fa fa-object-group"
  })]), _vm._v(" to convert the image to a micro note. Image keywords can be set in the next stage."), _vm._c('br')])])], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "main-content container-fluid xs-pt-0"
  }, [_vm._c('div', {
    staticClass: "row height-100"
  }, [_vm._c('div', {
    staticClass: "col-md-12 height-100"
  }, [(_vm.chapter) ? _vm._c('div', {
    staticClass: "height-100-minus"
  }, [(_vm.showReplaceWarning) ? _vm._c('div', {
    staticClass: "bg-danger clearfix"
  }, [_vm._c('p', {
    staticClass: "pull-left"
  }, [_vm._c('b', [_vm._v("Warning:")]), _vm._v(" You've created " + _vm._s(_vm.microNotes.length) + " micro notes based on this chapter. Those micro notes will be replaced. Are you sure you want to proceed?\n            ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "pull-right"
  }, [_vm._c('a', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.replaceMicroNotes($event)
      }
    }
  }, [_vm._v("\n                Replace\n              ")]), _vm._v(" "), _vm._c('a', {
    staticClass: "btn btn-default btn-sm btn-margin",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleReplaceWarning($event)
      }
    }
  }, [_vm._v("\n                Cancel\n              ")])])]) : _vm._e(), _vm._v(" "), (!_vm.saving) ? _vm._c('FroalaEditor', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.html),
      expression: "html"
    }],
    ref: "editor",
    attrs: {
      "chapterId": _vm.chapter.id,
      "config": _vm.froalaConfig
    },
    domProps: {
      "value": (_vm.html)
    },
    on: {
      "input": function($event) {
        _vm.html = $event
      }
    }
  }) : _vm._c('LoadingIndicator', {
    attrs: {
      "text": "Saving..."
    }
  }), _vm._v(" "), _vm._c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.statusMessage))])], 1) : _vm._c('div', [_vm._c('LoadingIndicator')], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aa5b77c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/micro-note-editor/MicroNoteCreator.vue
// module id = 704
// module chunks = 1